const initialCaseStudies = {
  caseStudies: [],
  caseStudy: {},
  errorMessage: '',
};

export default initialCaseStudies;
